import Joi from 'joi';


export const epfFormSchema = Joi.object({
  
    epfOrganizationNumber: Joi.string()
    .pattern(/^[a-zA-Z0-9]{15,22}$/)  // Ensures exactly 156 alphanumeric characters
    .required()
  
      
      
      .messages({
      "string.base": "EPF number is required.",

      "string.pattern.base": "EPF number must be between 15 and 22 alphanumeric characters.",
        "string.empty": "EPF number is required.",
        "any.invalid": "EPF number is required.",
      }),
    epfOrganizationStatus: Joi.string().required().messages({
      "string.base": "EPF status is required.",
      "string.empty": "EPF status is required.",
      "any.invalid": "EPF status is required.",
      }),
    epfOrganizationCoverageDate: Joi.string().required() .messages({
      "string.base": "Coverage Date is required.",
      "string.empty": "Coverage Date is required.",
      "any.invalid": "Coverage Date is required.",
      "any.required": "Coverage Date is required.",
      }),
    epfOrganizationEmployeeContribution: Joi.string()
      .valid('restrict_contribution', 'unrestricted_contribution')
      .required()  .messages({
        "string.base": "Employee Contribution is required.",
        "string.empty": "Employee Contribution is required.",
        "any.invalid": "Employee Contribution is required.",
      }),
    epfOrganizationEmployerContribution: Joi.string()
      .valid('restrict_contribution', 'unrestricted_contribution')
      .required()  .messages({
        "string.base": "Employer Contribution is required.",
        "string.empty": "Employer Contribution is required.",
        "any.invalid": "Employer Contribution is required.",
      }),
    epfOrganizationOffice: Joi.string() . allow(null, "")  .messages({
      "string.base": "Office is required.",
      "string.empty": "Office is required.",
      "any.invalid": "Office is required.",
      }),
    epfOrganizationAddress: Joi.string() . allow(null, "") .messages({
      "string.base": "Address is required.",
      "string.empty": "Address is required.",
      "any.invalid": "Address is required.",
      }),
    epfOrganizationCity: Joi.string()
    .min(2)
    .max(50)
    . allow(null, "")
    .messages({
      "string.empty": "City is required.",
      "string.min": "City must be at least 2 characters.",
      "string.max": "City must not exceed 50 characters.",
      "any.required": "City is required.",
    }),
    epfOrganizationState: Joi.number()
    .integer()
    .positive()
    . allow(null, "")
    .messages({
      "number.base": "State is required.",
      "number.integer": "State is required.",
      "number.positive": "State is required.",
      "any.required": "State is required.",
      "any.invalid": "State is required.",
    }),
    epfOrganizationCountry: Joi.number().integer().  allow(null, "") .messages({
      "string.pattern.base": "Country is required.",
      "string.empty": "Country is required.",
      "any.invalid": "Country is required.",
      }),
    epfOrganizationPinCode:   Joi.string().pattern(/^\d{6}$/) 
    . allow(null, "")
    
      .messages({
        "string.empty": "Pincode is required.",
        "string.pattern.base": "Pincode must be exactly 6 digits.",
        "any.required": "Pincode is required.",
      }),
    epfOrganizationLocation: Joi.string() . allow(null, "") .messages({
      "string.pattern.base": "Location is required.",
      "string.empty": "Location is required.",
      "any.invalid": "Location is required.",
      }),

    "epfOrganizationMaster1":  Joi.boolean(),
    "epfOrganizationMaster2":  Joi.boolean(),
    "epfOrganizationMaster3":  Joi.boolean(),
    "epfOrganizationMaster4":  Joi.boolean(),
  }).unknown(true);

// export const epfFormSchema = Joi.object({
//   under_epf_office: Joi.string()
//     .min(2)
//     .max(100)
//     .required()
//     .messages({
//       "string.empty": "Under EPF Office is required.",
//       "string.min": "Under EPF Office must be at least 2 characters.",
//       "string.max": "Under EPF Office must not exceed 100 characters.",
//       "any.required": "Under EPF Office is required.",
//     }),

//   address: Joi.string()
//     .min(5)
//     .max(200)
//     .required()
//     .messages({
//       "string.empty": "Address is required.",
//       "string.min": "Address must be at least 5 characters.",
//       "string.max": "Address must not exceed 200 characters.",
//       "any.required": "Address is required.",
//     }),

//   city: Joi.string()
//     .min(2)
//     .max(50)
//     .required()
//     .messages({
//       "string.empty": "City is required.",
//       "string.min": "City must be at least 2 characters.",
//       "string.max": "City must not exceed 50 characters.",
//       "any.required": "City is required.",
//     }),

//   state: Joi.string()
//     .valid("westbengal", "bihar")  // Ensure valid state options are selected
//     .required()
//     .messages({
//       "string.empty": "State is required.",
//       "any.only": "State must be one of the valid options.",
//       "any.required": "State is required.",
//     }),

//   country: Joi.string()
//     .valid("india", "usa")
//     .required()
//     .messages({
//       "string.empty": "Country is required.",
//       "any.only": "Country must be either India or USA.",
//       "any.required": "Country is required.",
//     }),

//   pincode: Joi.string()
//     .pattern(/^\d{6}$/)  // Ensures exactly 6-digit numeric pincode
//     .required()
//     .messages({
//       "string.empty": "Pincode is required.",
//       "string.pattern.base": "Pincode must be exactly 6 digits.",
//       "any.required": "Pincode is required.",
//     }),

//   location: Joi.string()
//     .min(2)
//     .max(100)
//     .required()
//     .messages({
//       "string.empty": "Location is required.",
//       "string.min": "Location must be at least 2 characters.",
//       "string.max": "Location must not exceed 100 characters.",
//       "any.required": "Location is required.",
//     }),
// });
